var level2Task1 = `
<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
  <variables>
    <variable id="a{b.t4dl(49*jk-XuN$8">my_number_of_siblings</variable>
  </variables>
  <block type="variables_set" id="h@eLI$BbzK~vgp~8Z9=)" x="12" y="12">
    <field name="VAR" id="a{b.t4dl(49*jk-XuN$8">my_number_of_siblings</field>
    <value name="VALUE">
      <block type="math_number" id=",B216XXVLk8zPAUAdb5y">
        <field name="NUM">2</field>
      </block>
    </value>
    <next>
      <block type="text_print" id="FN}Xj#:Z_A(uK9v,hQS">
        <value name="TEXT">
          <block type="variables_get" id="sfF,R8q!i[J~%G|CMtzo">
            <field name="VAR" id="a{b.t4dl(49*jk-XuN$8">my_number_of_siblings</field>
          </block>
        </value>
      </block>
    </next>
  </block>
</xml>
`
export default level2Task1